import { Box, Text } from '@chakra-ui/react'
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation'
import React from 'react'
const BillingInfo= ({text})=> {
  const { t } = useTranslator();
  return (
    <>
    <Box
    as="hr"
    width="calc(100% + 32px)" // Adjust width to account for padding (16px on each side)
    marginX="-16px" // Negative margin to offset the padding
    background= '#F9F9F9'

  />
    <Box padding="30px 16px 10px 16px">
      <Text color="#6B6B6B" fontFamily="Inter" fontWeight ={400} fontSize="20px" lineHeight="28px">
      { text ? text :t('otherModules.manage_payments_notice') || "Please check your settings/billing page on desktop to manage your payments."}</Text>
    </Box>
    </>
  )
}

export default BillingInfo;
